import {LongueursAchat} from '@/models';

export default [
	{
		path: '/longueurs-achat',
		name: 'longueursAchat',
		meta: {
			title: 'Liste des longueurs d\'achat ',
			granted: [ 'API_GET_LONGUEURSACHAT' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/LongueursAchat.vue')
	},
];